/**
 * Rozpoznaje wiersz zlecenia powiązany z Allegro (różne kształty pól z API).
 * Klasa wizualna: montage-row--allegro (#99FFFF).
 */
export const isAllegroMontageProductRow = (item) => {
  if (!item || item.isSummary) {
    return false;
  }

  const isTruthyFlag = (v) => v === true || v === 1 || v === "1";

  if (isTruthyFlag(item.is_allegro)) return true;
  if (isTruthyFlag(item.is_allegro_order)) return true;
  if (isTruthyFlag(item.from_allegro)) return true;

  const asAllegro = (v) =>
    String(v ?? "")
      .toLowerCase()
      .trim() === "allegro";

  const sources = [
    item.source,
    item.order_source,
    item.order__source,
    item.order_source_name,
    item.order?.source,
  ];
  if (sources.some(asAllegro)) return true;

  const label = String(
    item.order_source_label || item.source_label || ""
  ).toLowerCase();
  if (label.includes("allegro")) return true;

  return false;
};

/**
 * Zwraca string klas dla wiersza tabeli zleceń (EasyDataTable / natywny <tr>).
 * Zachowuje dotychczasowe exposing_data z API.
 */
export const montageProductRowClassName = (item) => {
  const parts = [];
  if (item?.exposing_data) {
    parts.push(String(item.exposing_data).trim());
  }
  if (isAllegroMontageProductRow(item)) {
    parts.push("montage-row--allegro");
  }
  if (!parts.length) {
    return false;
  }
  return parts.join(" ");
};
